module.exports = __webpack_public_path__ + "static/media/bannerpatjarkita.3d1ac74f.jpeg";